export function getDomainName() {
  return window.location.hostname
}
